<template>
  <div>
    <v-card class="mb-3">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>Укажите последнюю и минимальную поддерживаемую версию приложения для каждой платформы.</v-card-text>
    </v-card>
    <v-alert v-if="versionsError" type="error">
      {{ versionsError }}
      <v-btn text :loading="loading" @click="fetchVersions">Повторить</v-btn>
    </v-alert>
    <v-progress-linear v-if="loading" indeterminate class="mb-3" />
    <v-row v-if="loaded">
      <v-col v-for="platform in platforms" :key="platform.value" cols="12" md="6">
        <version-form :title="platform.text" :platform="platform.value"
          :version="versions[platform.value] || {}" :can-update="canEdit()" @saved="handleSaved" />
      </v-col>
    </v-row>
    <v-card class="mt-3">
      <v-card-title>История изменений</v-card-title>
      <v-card-text>
        <v-select v-model="platform" :items="platforms" label="Платформа" clearable
          placeholder="Все платформы" @change="filterHistory" />
        <v-alert v-if="historyError" type="error">
          {{ historyError }}
          <v-btn text :loading="historyLoading" @click="fetchHistory">Повторить</v-btn>
        </v-alert>
      </v-card-text>
      <v-data-table :headers="headers" :items="history" :options.sync="options"
        :server-items-length="total" :loading="historyLoading"
        :footer-props="{ itemsPerPageOptions: [5, 25, 50, 100] }" no-data-text="История изменений пуста">
        <template v-slot:[`item.platform`]="{ item }">{{ platformTitle(item.platform) }}</template>
        <template v-slot:[`item.created_at`]="{ item }">{{ formatHistoryDate(item.created_at) }}</template>
        <template v-slot:[`item.previous_latest`]="{ item }">{{ item.previous_latest == null ? '—' : item.previous_latest }}</template>
        <template v-slot:[`item.previous_minimal`]="{ item }">{{ item.previous_minimal == null ? '—' : item.previous_minimal }}</template>
        <template v-slot:[`item.changed_by_name`]="{ item }">
          {{ item.changed_by_name || '—' }}<span v-if="item.changed_by_id"> (#{{ item.changed_by_id }})</span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import VersionForm from '@/components/mobile-app-version/VersionForm.vue';
import { formatDateUnix } from '@/utils/date';

export default {
  components: { VersionForm },
  metaInfo() { return { title: this.title }; },
  data: () => ({
    title: 'Версии приложения',
    platforms: [{ text: 'Android', value: 'ANDROID' }, { text: 'iOS', value: 'IOS' }],
    platform: null, versions: {}, loaded: false, loading: false, versionsError: '',
    history: [], total: 0, historyLoading: false, historyError: '', historyRequest: 0,
    options: { page: 1, itemsPerPage: 25 },
    headers: [
      { text: '#', value: 'id', sortable: false },
      { text: 'Платформа', value: 'platform', sortable: false },
      { text: 'Последняя: до', value: 'previous_latest', sortable: false },
      { text: 'Последняя: после', value: 'latest', sortable: false },
      { text: 'Минимальная: до', value: 'previous_minimal', sortable: false },
      { text: 'Минимальная: после', value: 'minimal', sortable: false },
      { text: 'Автор', value: 'changed_by_name', sortable: false },
      { text: 'Дата', value: 'created_at', sortable: false }
    ]
  }),
  computed: {
    policies() {
      return this.$store.getters['user/policies'];
    }
  },
  watch: {
    options: { deep: true, handler() { this.fetchHistory(); } }
  },
  created() { this.fetchVersions(); },
  methods: {
    formatHistoryDate(value) {
      return formatDateUnix(value, 'DD.MM.YYYY HH:mm:ss') || '—';
    },
    canEdit() {
      return this.policies.includes('mobile_app_version_policy::update');
    },
    platformTitle(value) {
      const platform = this.platforms.find(item => item.value === value);
      return platform ? platform.text : value;
    },
    async fetchVersions() {
      this.loading = true;
      this.versionsError = '';
      try {
        const versions = await this.$api.mobileAppVersion.list();
        this.versions = versions.reduce((result, version) => {
          result[version.platform] = version;
          return result;
        }, {});
        this.loaded = true;
      } catch (error) {
        this.versionsError = error.message || 'Не удалось загрузить версии';
      } finally {
        this.loading = false;
      }
    },
    filterHistory() {
      if (this.options.page !== 1) this.options.page = 1;
      else this.fetchHistory();
    },
    async fetchHistory() {
      const request = ++this.historyRequest;
      this.historyLoading = true;
      this.historyError = '';
      this.history = [];
      try {
        const result = await this.$api.mobileAppVersion.history(
          this.options.page, this.options.itemsPerPage, this.platform
        );
        if (request !== this.historyRequest) return;
        this.history = result.data;
        this.total = result.paginatorInfo.total;
      } catch (error) {
        if (request !== this.historyRequest) return;
        this.total = 0;
        this.historyError = error.message || 'Не удалось загрузить историю';
      } finally {
        if (request === this.historyRequest) this.historyLoading = false;
      }
    },
    handleSaved(version) {
      this.$set(this.versions, version.platform, version);
      this.filterHistory();
    }
  }
};
</script>
